
import { Directive, Input, ElementRef } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';
import { Static } from '../../util/static';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[customMin][formControlName],[customMin][formControl],[customMin][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMinDirective, multi: true}]
})
export class CustomMinDirective implements Validator {
  @Input()
  customMin: number;
  // Separador de miles
  thousandsSeparator: string;
  // Separador de decimales
  decimalSeparator: string;

  constructor(private el?: ElementRef) {}

  /**
   * Validar mayor que
   *
   * @param {FormControl} c
   * @returns {{[key: string]: any}}
   * @memberof CustomMinDirective
   */
  validate(c: FormControl): {[key: string]: any} {
    if (this.el) {
      if (this.el.nativeElement.dataset.thousandsseparator) {
        this.thousandsSeparator = this.el.nativeElement.dataset.thousandsseparator;
      }
      if (this.el.nativeElement.dataset.decimalseparator) {
        this.decimalSeparator = this.el.nativeElement.dataset.decimalseparator;
      }
    }
    let v = c.value;
    if (String(v) !== '' && String(this.customMin) !== '') {
      v = Static.numberFormatWithoutThousandsSeparator(v, this.thousandsSeparator, this.decimalSeparator);
      if (Number(v) > Number(this.customMin)) {
        return null;
      } else {
        if (isNaN(v)) {
          return { 'format': true };
        } else {
          return { 'customMin': true };
        }
      }
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/custom-forms-validations/custom-min-validator.directive.ts